import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { AuthProvider } from 'customHooks/useAuth'
import GlobalStyles from 'globalStyles'
import ProtectRoute from 'components/ProtectRoute'
import HomeScreen from 'screens/HomeScreen'
import SearchResultOptionsScreen from 'screens/SearchResultOptionsScreen'
import RoomOptionsScreen from 'screens/RoomOptionsScreen'
import AddOnOptionsScreen from 'screens/AddOnOptionsScreen'
import CheckOutScreen from 'screens/CheckOutScreen'
import CheckOutConfirmScreen from 'screens/CheckOutConfirmScreen'
import ContactScreen from 'screens/ContactScreen'
import SignInScreen from 'screens/SignInScreen'
import SignUpScreen from 'screens/SignUpScreen'
import AccountScreen from 'screens/AccountScreen'
import SetPasswordScreen from 'screens/SetPasswordScreen'
import SetPasswordCompleteScreen from 'screens/SetPasswordCompleteScreen'
import ResetPasswordScreen from 'screens/ResetPasswordScreen'
import UnsubscribeScreen from 'screens/UnsubscribeScreen'
import CancellationPolicyScreen from 'screens/CancellationPolicy'
import TermsAndConditionsScreen from 'screens/TermsAndConditions'
import PrivacyPolicyScreen from 'screens/PrivacyPolicyScreen'
import FrequentlyAskedQuestionsScreen from 'screens/FrequentlyAskedQuestions'
import ForgotPasswordScreen from 'screens/ForgotPasswordScreen'
import HelpScreen from 'screens/HelpScreen'
import SignUpConfirmScreen from 'screens/SignUpConfirmScreen'
import {
  DataDeletionScreen,
  DataDeletionConfirmScreen,
} from 'screens/DataDeletionScreen';
import AuthCallbackGoogleScreen from 'screens/AuthCallbackGoogleScreen'
import AuthCallbackFacebookScreen from 'screens/AuthCallbackFacebookScreen'
import AuthCallbackXScreen from 'screens/AuthCallbackXScreen'
import AuthCallbackAppleScreen from 'screens/AuthCallbackAppleScreen'


const App: React.FC = () => {

  return (
    <AuthProvider >
      <GlobalStyles />
      <Switch>

        <Route path="/" exact>
          <HomeScreen />
        </Route>
        <Route path="/room-options" exact>
          <RoomOptionsScreen />
        </Route>
        <Route path="/add-on-options" exact>
          <AddOnOptionsScreen />
        </Route>
        <Route path="/check-out" exact>
          <CheckOutScreen />
        </Route>
        <Route path="/check-out-confirm" exact>
          <CheckOutConfirmScreen />
        </Route>
        <Route path="/contact-us" exact>
          <ContactScreen />
        </Route>
        <Route path="/data-deletion" exact>
          <DataDeletionScreen />
        </Route>

        <Route path="/data-deletion/confirm" exact>
          <DataDeletionConfirmScreen />
        </Route>
        <Route path="/sign-in" exact>
          <SignInScreen />
        </Route>
        <Route path="/sign-up" exact>
          <SignUpScreen />
        </Route>
        <Route path="/sign-up-confirm" exact>
          <SignUpConfirmScreen />
        </Route>
        <ProtectRoute path="/account" redirectPath="/sign-in">
          <AccountScreen />
        </ProtectRoute>
        <Route path="/search" render={() => <SearchResultOptionsScreen />} />
        <Route path="/setup" render={() => <SetPasswordScreen />} />
        <Route path="/setup-complete" exact render={() => <SetPasswordCompleteScreen />} />
        <Route path="/reset" render={() => <ResetPasswordScreen />} />
        <Route
          path="/unsubscribe"
          exact
          render={() => <UnsubscribeScreen />}
        />
        <Route path="/cancellation-policy" exact render={() => <CancellationPolicyScreen />} />
        <Route path="/terms-and-conditions" exact render={() => <TermsAndConditionsScreen />} />
        <Route path="/privacy-policy" exact render={() => <PrivacyPolicyScreen />} />
        <Route path="/faq" exact render={() => <FrequentlyAskedQuestionsScreen />} />
        <Route path="/forgot-password" exact render={() => <ForgotPasswordScreen />} />
        <Route path="/help" exact render={() => <HelpScreen />} />
        <Route path="/auth/callback/google" exact render={() => <AuthCallbackGoogleScreen />} />
        <Route path="/auth/callback/facebook" exact render={() => <AuthCallbackFacebookScreen />} />
        <Route path="/auth/callback/x" exact render={() => <AuthCallbackXScreen />} />
        <Route path="/auth/callback/apple" exact render={() => <AuthCallbackAppleScreen />} />

        {/* Redirects block */}
        <Redirect from="/roomOptions" to="/room-options" />
        <Redirect from="/addOnOptions" to="/add-on-options" />
        <Redirect from="/checkOut" to="/check-out" />
        <Redirect from="/checkOutConfirm" to="/check-out-confirm" />
        <Redirect from="/signIn" to="/sign-in" />
        <Redirect from="/signUp" to="/sign-up" />
        <Redirect from="/setupComplete" to="/setup-complete" />
        <Redirect from="/cancellationPolicy" to="/cancellation-policy" />
        <Redirect from="/termsAndConditions" to="/terms-and-conditions" />
        <Redirect from="/forgotPassword" to="/forgot-password" />
        <Redirect from="/Help" to="/help" />
        <Redirect from="/discover" to="/help" />

        {/* <Route path="/" exact>
          <HomeScreen />
        </Route>
        <Route path="/roomOptions" exact>
          <RoomOptionsScreen />
        </Route>
        <Route path="/addOnOptions" exact>
          <AddOnOptionsScreen />
        </Route>
        <Route path="/checkOut" exact>
          <CheckOutScreen />
        </Route>
        <Route path="/checkOutConfirm" exact>
          <CheckOutConfirmScreen />
        </Route>
        <Route path="/contact" exact>
          <ContactScreen />
        </Route>
        <Route path="/signIn" exact>
          <SignInScreen />
        </Route>
        <Route path="/signUp" exact>
          <SignUpScreen />
        </Route>
        <ProtectRoute path="/account" redirectPath="/signIn">
          <AccountScreen />
        </ProtectRoute>
        <Route path="/search" render={() => <SearchResultOptionsScreen />} />
        <Route path="/setup" render={() => <SetPasswordScreen />} />
        <Route path="/setupComplete" exact render={() => <SetPasswordCompleteScreen />} />
        <Route path="/reset" render={() => <ResetPasswordScreen />} />
        <Route path="/unsubscribe/:params" exact render={() => <UnsubscribeScreen />} />
        <Route path="/cancellationPolicy" exact render={() => <CancellationPolicyScreen />} />
        <Route path="/termsAndConditions" exact render={() => <TermsAndConditionsScreen />} />
        <Route path="/faq" exact render={() => <FrequentlyAskedQuestionsScreen />} />
        <Route path="/forgotPassword" exact render={() => <ForgotPasswordScreen />} />
        <Route path="/Help" exact render={() => <HelpScreen />} /> */}




      </Switch>
    </AuthProvider>
  )
}

export default App
